/**
 * Funner **server-side** AI HTTP API.
 *
 * Template generation uses `/api/ai/templates`. Ask AI in chat uses browser-side
 * integrations (`ask-ai-local-llm-chat.ts`) and does not call these endpoints.
 */
import { fetcher } from 'utils/axios';
import { OperatorAnalyze } from 'types/ai/ai-analyze';

interface AIApiResponse<T> {
  error: string | null;
  data: T;
}

export const fetchGetOperatorsAnalyze = async () => {
  try {
    const data = (await fetcher('get', '/api/Operators', 'newapi')) as Array<OperatorAnalyze> | null;
    if (data && typeof data === 'object') return data;
    else return [];
  } catch (error) {
    console.warn('fetchGetOperatorsAnalyze err: ', error);
    return [];
  }
};

export const fetchCreateAITemplateSession = async (): Promise<string | null> => {
  try {
    const res = (await fetcher('post', ['/api/ai/templates', { data: {} }], 'newapi')) as AIApiResponse<{
      thread: string;
    }> | null;

    if (!res?.error && res?.data?.thread) {
      return res.data.thread;
    }

    return null;
  } catch (error) {
    console.warn('fetchCreateAITemplateSession err: ', error);
    return null;
  }
};

export const fetchAskAITemplateSession = async (
  sessionId: string,
  question: string,
): Promise<string | null> => {
  try {
    const res = (await fetcher(
      'post',
      [`/api/ai/templates/${sessionId}/ask`, { data: { question } }],
      'newapi',
    )) as AIApiResponse<string> | null;

    if (!res?.error && typeof res?.data === 'string') {
      return res.data;
    }

    return null;
  } catch (error) {
    console.warn('fetchAskAITemplateSession err: ', error);
    return null;
  }
};
